/** @type {import('../schema').ProcessDefinition} */
const empleadosRecibos = {
  id: "empleados-recibos",
  name: "Recibos / nómina de empleados",
  category: "finanzas",
  outcome:
    "Poner a disposición del empleado sus liquidaciones mensuales (haberes, deducciones, neto).",
  trigger: "El Administrador genera/emite la liquidación del período.",
  actors: ["Administrador", "Sistema", "Empleado"],
  status: "PARCIAL",
  description:
    "El admin genera la liquidación mensual (payslips: borrador → emitido) con haberes y deducciones; el empleado la consulta, expande el detalle e imprime. La generación de la liquidación no tiene UI dedicada visible (admin/backend).",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "emp", actor: "Empleado" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Genera la liquidación (borrador)", description: "Período (YYYY-MM), haberes, deducciones, neto, horas/días (payslips, status: borrador)." },
    { id: "s2", laneId: "admin", type: "decision", label: "¿Emite la liquidación?" },
    { id: "s3", laneId: "admin", type: "task", label: "Ajusta el borrador", description: "Corrige conceptos antes de emitir." },
    { id: "s4", laneId: "admin", type: "document", label: "Emite (status: emitido)" },
    { id: "s5", laneId: "sys", type: "notification", label: "Disponible para el empleado", description: "La liquidación emitida queda visible en su panel." },
    { id: "s6", laneId: "emp", type: "task", label: "Consulta el recibo", description: "Lista sus liquidaciones por período (solo lectura).", evidence: "src/screens/employee/RecibosEmployee.jsx:37" },
    { id: "s7", laneId: "emp", type: "task", label: "Expande el detalle e imprime", description: "Ve haberes/deducciones por concepto e imprime el recibo." },
    { id: "s8", laneId: "emp", type: "end", label: "Recibo consultado" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s4", label: "sí" },
    { from: "s2", to: "s3", label: "no" },
    { from: "s3", to: "s2" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
  ],
};

export default empleadosRecibos;
